<script setup lang="ts">
import { userModule } from '@/store/user/module'
import { computed } from 'vue'
import UIKit from '@pocketprep/ui-kit'
import type { Study } from '@pocketprep/types'
import type { ClientExam } from '@/store/bundle/state'
const {
    ModalContainer,
    Button: PocketButton,
} = UIKit

defineProps<{
    examName: string | undefined
    currentExam: Study.Class.ExamMetadataJSON | ClientExam | null
}>()

const emit = defineEmits<{
    close: []
    'reviewExamVersions': []
}>()

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})
</script>

<template>
    <Portal to="modal">
        <ModalContainer
            key="newMajorExamVersionModal"
            :show-close-button="true"
            :is-dark-mode="isDarkMode"
            @close="emit('close')"
        >
            <div class="new-major-exam-version-modal">
                <div class="new-major-exam-version-modal__title">
                    New Exam Version Available
                </div>
                <div v-if="currentExam?.releaseInfo?.message" class="new-major-exam-version-modal__content">
                    {{ currentExam?.releaseInfo.message }}
                </div>
                <div v-else class="new-major-exam-version-modal__content">
                    {{ examName }} has a new exam version.
                    We have new exam prep content (questions, explanations, and references)
                    if you’re preparing for the new version.
                </div>
                <div
                    class="new-major-exam-version-modal__actions"
                >
                    <PocketButton
                        class="new-major-exam-version-modal__close-btn"
                        :isDarkMode="isDarkMode"
                        type="secondary"
                        @click="emit('close')"
                    >
                        Close
                    </PocketButton>
                    <PocketButton
                        class="new-major-exam-version-modal__review-version-btn"
                        :isDarkMode="isDarkMode"
                        @click="emit('reviewExamVersions')"
                    >
                        Review Exam Versions
                    </PocketButton>
                </div>
            </div>
        </ModalContainer>
    </Portal>
</template>

<style lang="scss" scoped>
.new-major-exam-version-modal {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__title {
        font-size: 18px;
        font-weight: 600;
        line-height: 25px;
        letter-spacing: 0.3px;
        text-align: center;
        margin-top: 36px;
        margin-bottom: 12px;
    }

    &__content {
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        width: 298px;
        margin: 0 38px 32px 38px;
    }

    &__actions {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &__close-btn,
    &__review-version-btn {
        margin-bottom: 24px;
        margin-left: 6px;
    }
}
</style>
